import { Modal, Descriptions } from "antd";

const ViewBankDetails = ({ open, subHeader, onCancel, rowData }) => {
  const bankDetails = [
    {
      label: "Bank Name",
      value: rowData?.bankName || "N/A",
    },
    {
      label: "Account Name",
      value: rowData?.accountName || "N/A",
    },
    {
      label: "Account Number / IBAN",
      value: rowData?.accountNumberOrIBAN || "N/A",
    },
  ];

  return (
    <Modal
      open={open}
      width={700}
      footer={null}
      closable={false}
      centered
      destroyOnClose
      onCancel={onCancel}
      styles={{ body: { padding: 0 } }}
    >
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
        <div className="flex items-center justify-between">
          <h3 style={{ width: "100%" }} className="text-lg font-semibold m-0">
            {subHeader || "Bank Account Details"}
          </h3>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <Descriptions
          bordered
          size="middle"
          column={1}
          labelStyle={{
            width: "max-content",
            whiteSpace: "nowrap",
            fontWeight: 600,
          }}
          style={{ display: "flex", flexDirection: "column" }}
          contentStyle={{ fontWeight: 500 }}
        >
          {bankDetails.map((item, idx) => (
            <Descriptions.Item
              key={idx}
              label={
                <div className="flex items-center gap-2">{item.label}</div>
              }
            >
              {item.value}
            </Descriptions.Item>
          ))}
        </Descriptions>
      </div>
    </Modal>
  );
};

export default ViewBankDetails;
